let build = "development"
if (window.location.href.indexOf("https://portal.britesignal.com") !== -1) {
  build = 'production'
}
export default {
  build
}